<template>
  <div id="app">
	<div class="showPC" v-if="isDef">
		<navBar :activeIndex="activeIndex"></navBar>
	 </div>
	<div class="showMobile" v-if="isDef">
		<mobile-nav></mobile-nav>
	 </div>
	 <transition :name="transitionName">  
		<router-view class='x-panel'></router-view>
	 </transition>
	 <footer-address v-if="isDef"></footer-address>
  </div>
</template>

<script>
import navBar from '../components/navBar';
import mobileNav from '../components/mobileNav';
import footerAddress from '../components/footerAddress';
export default {
  components: {
	navBar,
	mobileNav,
	footerAddress  
  },
  data(){
  	return{ 
		isDef: true,
  		activeIndex:this.$route.path,
		transitionName:''
  	}
  }, 
		mounted() {			
			console.log('1341255，', this.activeIndex)	
			if(this.activeIndex == '/ktv')
			{
				this.isDef = false;
				console.log('zzzzzff')
			} 	
		},
   watch: {
    $route(to, from) { 
		{ 
			if(to.meta.index > from.meta.index){
				this.transitionName = 'slide-left';
			}else{
				this.transitionName = 'slide-right';
			}
		}
    }
   }
}
</script>

<style>
.el-button{
	padding: unset !important;
}
.jiufen{
	color: #333;
	text-align: left;
	width: 1200px;
	margin: 0 auto;
}
.jiufenC{
	color: #333;
	text-align: center;
	font-size: 30px;
	height: 80px;
	line-height: 80px;
}
.jiufneCint{
	font-size: 14px;
	color: #333;
	line-height: 30px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} 
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
 will-change: transform;
 transition: all 500ms;
}
.slide-right-enter {
 opacity: 0;
 transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
 opacity: 0;
 transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
 opacity: 0;
 transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
 opacity: 0;
 transform: translate3d(-100%, 0, 0);
}
*{
	margin: 0;
	padding: 0;
}
body{
	margin: 0;
	padding: 0; 
}
#app{
	background-color: #eff0f3;
}
.clear{
	clear: both;
}
.banners{
		background-image: url('../assets/images/img1.jpg');
		background-size: 100%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
	}
@media screen and (min-width: 600px) and (max-width: 1200px){
	.item2-title{
		font-size: 2vw;
	}
	.pLcont{
		font-size: 2.8vw;
		color: #646566;
		line-height: 6vw;
		margin-bottom: 3vw;
		margin-top: 2vw;
		flex: 1;
	}
	.banner-bottom{
		position: absolute;
	}
	.topFar{
		padding-top: 6vw;
	}
	.topFar1{
		padding-top: 4vw;
	}
	.el-button{
		margin-left: 1vw !important;
	}
	.banner2{
		background-image: url("../assets/images/img2.jpg");
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw;
	}
	.banners{
		background-image: url("../assets/images/img12.jpg");
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw !important;
	}
	.banner4{
		background-image: url('../assets/images/img16.jpg');
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw;
	}
	.banner3{
		background-image: url('../assets/images/temb6.png');
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw;
	}
	.banner-5{
		background-image: url("../assets/images/img-5.jpg");
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw;
		cursor: pointer;
	}
	.banner6{
		background-image: url("../assets/images/def/hand.jpg");
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw;
		cursor: pointer;
	}
	.bigBox{
		width: 100%;
	}
	.pImg{
		width: 100%;
	}
	.pcont{
		margin-bottom: unset !important;
	}
	.banner{
		height: 55vw;
		width: 100vw;
		background-repeat: no-repeat;
		background-size: 165%;
	}
	.title{
		font-size: 6vw;
		color: #333;
	}
	.ptitle{
		font-size: 4vw;
		color: #333;
		text-align: center;
		margin-top: 5vw;
	}
	.pcont{
		text-align: left;
		padding: 5vw;
	}
	.pLTitle{
		font-size: 3vw;
		color: #323233;
		line-height: 3.8vw;
		font-weight: bold;
		margin: unset !important;
		margin-bottom: 2vw !important;
		margin-top: 2vw !important;
	}
	.knowMore{
		display: none;
	}
	.guideC{
		display: none;
	}
	.textCss5{
		flex: 1;
	}
	.bigChain{
		padding-right: 0 !important;
		flex: 1;
		text-align: left;
	}
	.sBox{
		width: 100vw;
		margin-top: 5vw;
	}
	.chanPic{
		width: 100%;
		margin-top: 3vw;
	}
	.chainT{
		padding-top: 5vw;
		font-size: 4vw;
		line-height: 4vw;
		font-weight: 500;
		margin-bottom: 2vw;
	}
	.chainTs{
		padding-top: 5vw;
		font-size: 4vw;
		line-height: 4vw;
		font-weight: 500;
		margin-bottom: 2vw;
	}
	.chainC{
		padding: 5vw;
	}
	.chainCtxt2{
		font-size: 2.8vw;
		color: #999;
		line-height: 4vw;
		text-align: left;
	}
	.guideLM{
		display: flex;
		margin-bottom: 5vw;
	}
	.chainCtxt1{
		font-size: 3vw;
		color: #333;
		line-height: 7.6vw;
		font-weight: 500;
		text-align: left;
	}
	.sCont{
		margin-top: 2vw;
		font-size: 3vw;
		color: #646566;
	}
	.ssBox{
		width: 100%;
		margin-top: 5vw;
		padding-bottom: 5.5vw;
	}
	.itemBox{
		float: left;
		width: 14vw;
		margin-left: 5vw;
		margin-top: 3vw;
	}
	.itemText{
		margin-top: 2vw;
		font-size: 3vw;
		color: #333;
		
	}
	.itemPic{
		display: block;
		margin: 0 auto;
		width: 12vw;
		height: 12vw;
	}
		html{
			font-size: 5px;
			background-color: #eff0f3;
		}
		.showPC{
			display: none;
		}
		.showMobile{
			display: block;
		}
		.leftCont{
			background-color: #fff;
			width: 100%;
			margin-top: 4rem;
		}
		.name{
			padding-top: 4vw;
			font-size: 4.4vw;
			line-height: 10.4vw;
			text-align: center;
		}
		.Intro{
			font-size: 3vw;
			line-height: 6vw;
			font-weight: 300;
			text-align: center;
		}
		.el-dialog{
			width: 90% !important;
		}
		span{
			font-size: 2.8rem !important;
		}
		.el-dropdown{
			line-height: 4rem !important;
		}
		.mendio1{
			background-color: rgba(0,0,0,0.4);
			height: 50vw;
			padding-top: 5vw;
		}
		.mendio2{
			background-color: rgba(0,0,0,0.4);
			height: 55vw;
		}
		.mendio{
			background-color: rgba(0,0,0,0.2);
			height: 55vw;
			
		}
		.Ufree{
			width: 32vw;
			margin-left: 2vw;
			border-radius: 0.2vw !important;
			font-size: 2.8vw !important;
			text-align: center !important;
			background: #ff6a00 !important;
			border: 0.1rem solid #ff6a00 !important;
			font-weight: 500 !important; 
			height: 6vw !important;
			line-height: 6vw !important;
			color: #fff !important;
			display: inline-block !important;
			cursor: pointer !important;
			padding: unset !important;
			margin-top: 3vw !important;
			/* margin-left: 35vw !important; */
		}
		.Comuni{
			font-size: 2.8vw;
			margin-top: 1.8vw;
			color: #cacaca;
			line-height: 6vw;
			text-align: center;
		}
		.ContPic{
			width: 100%;
		}
		.othersPic{
			width: 100%;
		}
}
.pcont-bk{
	background-color: #fafbfc;
}
.strbox{
	background-color: #fafbfc;
}


.callMe{
	font-size: 14px;
	color: #646566;
	text-align: center;
	margin-top: 24px;
}

.bigBox{
	display: flex;
}

@media screen and (min-width: 1200px){
	html{
			font-size: 10px;
			background-color: #eff0f3;
		}
	/* 	.strbox{
			padding-top: 50px;
		} */
		.mendio{
			height: 338px;
			padding-left: 56px;
			background-color: rgba(0,0,0,0.2);
		}
	/* 	.pcont-bk{
			padding-top: 50px;
		} */
		.showPC{
			display: block;
		}
		.showMobile{
			display: none;
		}
	.banner2{
		background-image: url("../assets/images/img2.jpg");
		background-size: 100%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff; 
		width: 1200px;
		background-color: rgba(0,0,0,0.1);
	}
	.banners{
		background-image: url("../assets/images/img12.jpg");
		background-size: 100%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff; 
		width: 1200px !important;
	}
	.mendio1{
		padding-left: 56px;
		padding-top: 56px;
		padding-bottom: 51px;
		background-color: rgba(0,0,0,0.4);
	}
	.banner4{
		background-image: url('../assets/images/img16.jpg');
		background-size: 100%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff; 
		width: 1200px;
	}
	.banner3{
		background-image: url('../assets/images/temb6.png');
		background-size: 100%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff; 
		width: 1200px;
	}
	.banner-5{
		background-image: url("../assets/images/img-5.jpg");
		background-size: 100%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		width: 1200px;
		cursor: pointer;
	}
	.banner6{
		background-image: url("../assets/images/def/hand.jpg");
		background-size: 100%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		width: 1200px;
		cursor: pointer;
	}
	.mendio2{
		padding: 61px 28px;
		background-color: rgba(0,0,0,0.4);
	}
	.leftCont{
		background-color: #fff;
		width: 1200px;
	}
	.fistLit{
		display: flex;
	}
	.centbox{
		width: 30px;
		float: left;
	}
	.forTst{
		font-size: 14px;
		color: #323233;
		line-height: 20px;
	}
	.forImg{
		display: block;
		width: 40px;
		height: 40px;
		margin: 0 auto 8px;
		border-radius: 2px;
	}
	.forsmbox22{
		width: 88px;
		padding-top: 24px;
	}
	.forsmbox{
		min-width: 56px;
		padding-top: 24px;
		flex: 1;
	}
	.fortitle{
		font-size: 16px;
		color: #323233;
		line-height: 24px;
		text-align: left;
		font-weight: 600;
	}
	.forBox{
		background-color: #fff;
		margin-bottom: 16px;
		padding: 24px;
	}
	.thidBox{
		display: flex;
		background-color: #fff;
		padding: 24px 0;
		margin-bottom: 16px;
		line-height: 0;
	}
	.thImgBx{
		flex: 1;
	}
	.thImg{
		width: 32px;
		height: 32px;
		margin: 0 auto;
	}
	.seeMore{
		color: #07d;
		text-decoration: none;
	}
	.hrline{
		margin: 16px auto 14px;
		border: none;
		height: 1px;
		width: 266px;
		background-color: #ebedf0;
	}
	.aImg{
		display: inline-block;
		margin-left: 12px;
		width: 53px;
		height: 40px;
		vertical-align: top;
	}
	.secContbox{
		display: flex;
		margin-top: 16px;
		cursor: pointer;
	}
	.showAn{
		width: 197px;
		font-size: 14px;
		color: #323233;
		line-height: 20px;
		text-align: left;
		display: inline-block;
		text-overflow: ellipsis;
		overflow: hidden;
		height: 40px;
	}
	.secSbox{
		margin-left: 12px;
		vertical-align: bottom;
		font-weight: 500;
		display: inline-block;
		border-radius: 2px;
		font-size: 12px;
		line-height: 20px;
		padding: 2px 10px;
		background-color: rgba(26,115,239,.13);
	}
	.secTitle{
		text-align: left;
		font-size: 16px;
		line-height: 24px;
		color: #323233;
		font-weight: 600;
	}
	.secBox{
		background-color: #fff;
		margin-bottom: 16px;
		padding: 24px 24px 15px;
	}
	.callNow{
		color: #155bd4;
		background-color: #fff;
		margin: 24px 20px 0;
		font-size: 14px;
		line-height: 36px;
		display: block;
		border-radius: 2px;
	}
	.test{
		color: #fff;
		border: 1px solid #fff;
		margin: 12px 20px 0;
		font-size: 14px;
		line-height: 36px;
		display: block;
		border-radius: 2px;
	}
	.fstTxt{
		font-size: 16px;
		line-height: 20px;
		margin-bottom: 4px;
	}
	.fstPic{
		display: block;
		width: 56px;
		height: 56px;
		border-radius: 50%;
		margin: 0 auto 12px;
		cursor: pointer;
	}
	.firstSm{
		width: 264px;
		padding: 20px 0;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		position:unset;
	}
	.firstBt{
		background-image: url('../assets/images/def/bt-bg.jpg');
		width: 266px;
		height: 262px;
		background-repeat: no-repeat;
		background-size: 100%;
		border-radius: 5px;
	}
	.firstB{
		background-color: #fff;
		padding: 24px 24px 21px;
		margin-bottom: 16px;
	}
	.othersPic{
		width: 100%;
	}
	.guideBox{
		padding-bottom: 55px;
	}
	.ContPic{
		width: 790px;
	}
	.canLine{
		width: 30px;
	}
	.smallBox{
		flex: 1;
	}
	.Gcont1{
		font-size: 16px;
		color: #fff;
		line-height: 24px;
	}
	.Gcont2{
		width: 24px;
		height: 3px;
		margin-top: 15px;
		margin-bottom: 16px;
		background-color: #fff;
	}
	.Gcont3{
		font-size: 14px;
		color: #fff;
		line-height: 24px;
	}
	.guidePcC{
		display: flex;
		text-align: left;
		margin-top: 30px;
		margin-bottom: 25px;
		-webkit-box-pack: justify;
		justify-content: space-between;
	}
	.guidePcT{
		padding-bottom: 20px;
		padding-top: 20px;
		font-size: 14px;
		color: #fff;
		line-height: 20px;
		border-bottom: 1px solid hsla(0,0%,85%,.29)
	}
	.guidePic{
		background-image: url('../assets/images/def/swiper-bg.png');
		flex: 1;
		height: 300px;
		padding-bottom: 40px;
		padding: 0 24px;
	}
	.guideL{
		display: block;
		width: 152px;
		line-height: 22px;
		font-size: 16px;
		padding: 2px 4px;
		color: #666;
		text-align: center;
		cursor: pointer;
		border-bottom: 2px solid #fff;
	}
	.guideActive{
		border-bottom: 2px solid #ff6a00;
		color: #ff6a00;
		width: 66px;
		margin: 0 auto;
		margin-bottom: 24px;
	}
	.guideText{
		margin: 0 auto;
		margin-bottom: 24px;
		width: 66px;
	}
	.guideC{
		display: flex;
	}
	.guideLM{
		display: none;
	}
	.knowMore{
		margin-top: 24px;
		display: block;
		color: #ff6a00;
		font-size: 14px;
		text-align: left;
	}
	.bigChain{
		padding-right: 30px;
		flex: 1;
	}
	.chainC{
		display: flex;
	}
	.chanPic{
		flex: 1;
		width: 360px;
		height: 305px;
	}
	.chainCtxt1{
		font-size: 18px;
		color: #333;
		line-height: 28px;
		font-weight: 500;
	}
	.chainCtxt2{
		font-size: 14px;
		color: #999;
		line-height: 20px;
		margin-top: 8px;
	}
	.chainCtxt{
		margin-bottom: 40px;
		text-align: left;
	}
	.chainT{
		font-size: 26px;
		line-height: 30px;
		font-weight: 500;
		margin-bottom: 50px;
		padding-top: 50px;
	}
	.chainTs{
		font-size: 26px;
		line-height: 30px;
		font-weight: 500;
		margin-bottom: 50px;
	}
	.chain{
		width: 710px;
		margin: 0 auto;
	}
	.pImg{
		width: 300px;
	}
	.emtyImg{
		padding: 50px 0 0 0;
		/* height: 325px; */
	}
	.pLeft{
		padding-right: 30px;
		flex: 1;
	}
	.pReft{
		padding-left: 30px;
		flex: 1;
	}
	.pcont{
		display: flex;
		width: 910px;
		margin: 0 auto;
		margin-bottom: 24px;
	}
	.pLTitle{
		margin-top: 82px;
		font-size: 20px;
		color: #323233;
		line-height: 28px;
		font-weight: 500;
		flex: 1;
	}
	.pLcont{
		font-size: 14px;
		color: #646566;
		line-height: 20px;
		margin-top: 8px;
		flex: 1;
	}
	.bigBox{
		width: 1200px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.ptitle{
		font-size: 26px;
		line-height: 30px;
		font-weight: 500;
		margin-bottom: 50px;
		padding-top: 50px;
		text-align: center;
	}
	.ssBox{
		display: flex;
		margin-top: 50px;
		padding-bottom: 55px;
	}

	.itemBox{
		flex: 1;
	}
	.itemText{
		margin-top: 30px;
		font-size: 14px;
		color: #333;
	}
	.itemPic{
		display: block;
		margin: 0 auto;
		width: 64px;
		height: 64px;
	}
	.banner{
		height: 338px;
		width: 1200px;
	}
	.name{
		padding-top: 30px;
		font-size: 34px;
		line-height: 52px;
	}
	.Intro{
		font-size: 20px;
		margin-top: 10px;
		font-weight: 300;
		line-height: 28px;
	}
	.Ufree{
		width: 158px !important;
		margin-top: 40px !important;
		line-height: 38px !important;
		border-radius: 2px !important;
		font-size: 14px !important;
		text-align: center !important;
		background: #ff6a00 !important;
		border: 1px solid #ff6a00 !important;
		font-weight: 500 !important; 
		color: #fff !important;
		cursor: pointer !important;
		padding: unset !important;
	}
	.Comuni{
		font-size: 14px;
		margin-top: 8px;
		color: #cacaca;
		line-height: 20px;
	}
	.sBox{
		width: 750px;
		margin: 0 auto;
	}
	.title{
		padding-top: 50px;
		font-size: 26px;
		line-height: 30px;
		font-weight: 500;
	}
	.sCont{
		margin-top: 8px;
		line-height:20px;
		font-size: 15px;
		color: #646566;
	}
}
@media screen and (max-width: 600px){
	.item2-title{
		font-size: 2vw;
	}
	.topFar1{
		padding-top: 5vw;
	}
	html{
		font-size: 5px;
		background-color: #eff0f3;
	}
	.showPC{
		display: none;
	}
	.showMobile{
		display: block;
	}
	.leftCont{
		background-color: #fff;
		width: 100%;
		margin-top: 4rem;
	}
	.topFar{
		padding-top: 5vw;
	}
	.name{
		padding-top: 6vw;
		font-size: 5vw;
		line-height: 8.4vw;
		text-align: center;
	}
	.Intro{
		font-size: 3vw;
		line-height: 5vw;
		font-weight: 300;
		text-align: center;
	}
	.el-dialog{
		width: 90% !important;
	}
	span{
		font-size: 2vw !important;
	}
	.el-dropdown{
		line-height: 4rem !important;
	}
	.mendio1{
		background-color: rgba(0,0,0,0.4);
		height: 50vw;
		padding-top: 5vw;
	}
	.mendio2{
		background-color: rgba(0,0,0,0.4);
		height: 55vw;
	}
	.mendio{
		background-color: rgba(0,0,0,0.4);
		height: 55vw;
		
	}
	.Ufree{
		width: 32vw;
		margin-left: 2vw;
		border-radius: 0.2vw !important;
		font-size: 2vw !important;
		text-align: center !important;
		background: #ff6a00 !important;
		border: 0.1rem solid #ff6a00 !important;
		font-weight: 500 !important; 
		height: 8vw !important;
		line-height: 8vw !important;
		color: #fff !important;
		display: inline-block !important;
		cursor: pointer !important;
		padding: unset !important;
		margin-top: 4vw !important;
		/* margin-left: 35vw !important; */
	}
	.Comuni{
		font-size: 2.8vw;
		margin-top: 1.6vw;
		color: #cacaca;
		line-height: 4vw;
		text-align: center;
	}
	.ContPic{
		width: 100%;
	}
	.othersPic{
		width: 100%;
	}
	.pLcont{
		font-size: 2.4vw;
		color: #646566;
		line-height: 4vw;
		margin-bottom: 3vw;
		margin-top: 2vw;
		flex: 1;
	}
	.banner{
		background-image: url('../assets/images/img1.jpg');
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
	}
	.el-button{
		
	}
	
	.el-button{
		margin-left: 1vw !important;
	}
	.banner2{
		background-image: url("../assets/images/img2.jpg");
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw;
	}
	.banners{
		background-image: url("../assets/images/img12.jpg");
		background-size: 142%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw !important;
	}
	.banner4{
		background-image: url('../assets/images/img16.jpg');
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw;
	}
	.banner3{
		background-image: url('../assets/images/temb6.png');
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw;
	}
	.banner-5{
		background-image: url("../assets/images/img-5.jpg");
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw;
		cursor: pointer;
	}
	.banner6{
		background-image: url("../assets/images/def/hand.jpg");
		background-size: 165%;
		background-repeat: no-repeat;
		text-align: left;
		color: #fff;
		height: 55vw;
		width: 100vw;
		cursor: pointer;
	}
	.bigBox{
		width: 100%;
	}
	.pImg{
		width: 100%;
	}
	.pcont{
		margin-bottom: unset !important;
	}
	.banner{
		height: 55vw;
		width: 100vw;
		background-repeat: no-repeat;
		background-size: 140%;
	}
	.title{
		font-size: 4vw;
		font-weight: bold;
		color: #333;
	}
	.ptitle{
		font-size: 3.5vw;
		color: #333;
		text-align: center;
		margin-top: 5vw;
		font-weight: bold;
	}
	.pcont{
		text-align: left;
		padding: 5vw;
	}
	.pLTitle{
		font-size: 3vw;
		color: #555;
		line-height: 5.6vw;
		font-weight: bold;
		margin-top: 2vw !important;
		margin-bottom: 2vw;
	}
	.knowMore{
		display: none;
	}
	.guideC{
		display: none;
	}
	.textCss5{
		flex: 1;
	}
	.bigChain{
		padding-right: 0 !important;
		flex: 1;
		text-align: left;
	}
	.sBox{
		width: 100vw;
		margin-top: 5vw;
	}
	.chanPic{
		width: 100%;
		margin-top: 3vw;
	}
	.chainT{
		padding-top: 5vw;
		font-size: 3vw;
		line-height: 6vw;
		font-weight: 500;
		margin-bottom: 2vw;
	}
	.chainTs{
		padding-top: 5vw;
		font-size: 3vw;
		line-height: 6vw;
		font-weight: 500;
		margin-bottom: 2vw;
	}
	.chainC{
		padding: 5vw;
	}
	.chainCtxt2{
		font-size: 2.4vw;
		color: #999;
		line-height: 4vw;
		text-align: left;
	}
	.guideLM{
		display: flex;
		margin-bottom: 5vw;
	}
	.chainCtxt1{
		font-size: 2.8vw;
		color: #333;
		line-height: 5.6vw;
		font-weight: 500;
		text-align: left;
	}
	.sCont{
		margin-top: 2vw;
		font-size: 2rem;
		color: #646566;
	}
	.ssBox{
		width: 100%;
		margin-top: 5vw;
		padding-bottom: 5.5vw;
	}
	.itemBox{
		float: left;
		width: 14vw;
		margin-left: 5vw;
		margin-top: 3vw;
	}
	.itemText{
		margin-top: 2vw;
		font-size: 2vw;
		color: #333;
		
	}
	.itemPic{
		display: block;
		margin: 0 auto;
		width: 12vw;
		height: 12vw;
	}
}
.pBox{
	text-align: left;
}
.pBox2{
	text-align: left;
	background-color: #f7f8fa;
}
</style>
